// extracted by mini-css-extract-plugin
export default {"wrapper":"ProgressCell_wrapper__w0bto","progressBar":"ProgressCell_progressBar__8x0ui","resolved":"ProgressCell_resolved__vzPck","unresolved":"ProgressCell_unresolved__F4UgM"};